var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"data-testid":"loader"}},[_c('img',{attrs:{"src":"/img/loader.gif","alt":"loader-image","data-testid":"loader__image"}}),_c('br')])
}]

export { render, staticRenderFns }